import axios from 'axios';
import { keys } from '../config/keys';

const api = axios.create({
  baseURL: keys.ServicePath,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;